import moment from "moment";
import React, { useState } from "react";
import Table2 from "../../../../templates/components/Table2";
import Utilities from "../../../../../services/commonservice/utilities";
import ModalBox from "../../../../templates/components/ModalBox";
import SoapNotesEdit from "./soap-notes-edit/SoapNotesEdit";

const SoapNotesTable = (props) => {
  const [soapNotes, setSoapNotes] = useState(props.soapNotes || []);
  const [selectedSoapNotes, setSelectedSoapNotes] = useState();
  const [openModal, setOpenModal] = useState(false);

  const tableColumns = [
    {
      id: "subjective",
      Header: "Subjective",
      accessor: (cell) => cell.subjective || "",
    },
    {
      id: "createdOn",
      Header: "Created On",
      accessor: (tc) => moment(tc.createdOn).format("MM-DD-YYYY h:mm A"),
    },
    {
      id: "objective",
      Header: "Objective",
      accessor: (cell) => cell.objective || "",
    }, {
      id: "assessment",
      Header: "Assessment",
      accessor: (cell) => cell.assessment || "",
    },
    {
      id: "plan",
      Header: "Plan",
      accessor: (cell) => cell.plan || "",
    },
    {
      id: "action",
      Header: "Action",
      disableSortBy: true,
      textAlign: 'center',
      accessor: (cell, i) => {
        return (
          <div className="d-flex justify-content-center">
            <button
              className="p-0 ps-1 btn btn-primary"
              title="Edit Soap Notes"
              onClick={(e) => {
                e.preventDefault();
                setSelectedSoapNotes(cell);
                return setOpenModal(true);
              }}
            >
              <i className="icon pencil" />
            </button>
          </div>
        );
      },
    },
  ];
  return (
    <>
      <div title="SoapNotes" className="py-3">
        <Table2
          data={soapNotes}
          columns={tableColumns}
          loading={props?.loading}
        />
      </div>
      <ModalBox open={openModal} onClose={() => setOpenModal(false)} title="Edit Soap Notes">
        {selectedSoapNotes && <SoapNotesEdit
          initialData={selectedSoapNotes}
          onClose={() => {
            setOpenModal(false);
          }}
          refresh={() => { props.refresh() }}
        />}
      </ModalBox>
    </>
  );
};

export default SoapNotesTable;
